<template>
  <BaseModal
    :open="open"
    class="days-count-modal"
    title="Liczba dni jadłospisu"
    :submit-label="warning ? 'Zapisz i usuń dni' : 'Zapisz'"
    :submit-disabled="targetDaysCount === null"
    @update:open="!$event && emit('close')"
    @confirm="emit('save')"
  >
    <template #icon>
      <FeaturedIcon
        background-color="color-background-bg-primary"
        icon-color="color-text-text-secondary-700"
        name="Settings01"
        size="md"
      />
    </template>
    <Space :space="8">
      <RadioGroup
        class="days-count-modal__presets"
        :items="presetItems"
        label="Wybierz liczbę dni jadłospisu"
        name="days-count-preset"
        orientation="horizontal"
        :model-value="preset"
        required
        @update:model-value="emit('preset', $event)"
      />
      <Select
        v-if="preset === 'custom'"
        class="days-count-modal__select"
        :items="dayItems"
        label="Podaj liczbę dni"
        :model-value="selectedDays"
        required
        @update:model-value="
          emit('days', typeof $event === 'number' ? $event : null)
        "
      />
      <Badge v-if="warning" color="error" icon="AlertTriangle"> {{ warning }} </Badge>
    </Space>
  </BaseModal>
</template>
<script lang="ts" setup>
  import { Space } from '@/components/Space'
  import { BaseModal, FeaturedIcon, RadioGroup, Select } from '@/components/ui'
  import Badge from '@/components/ui/Badge/Badge.vue'

  type Preset = 7 | 14 | 21 | 28 | 'custom'

  defineProps<{
    dayItems: { id: number; label: string }[]
    open: boolean
    preset: Preset
    presetItems: { id: Preset; label: string }[]
    selectedDays: number | null
    targetDaysCount: number | null
    warning: string | null
  }>()
  const emit = defineEmits<{
    close: []
    days: [value: number | null]
    preset: [value: number | string]
    save: []
  }>()
</script>
<style lang="scss">
.days-count-modal__presets .ui-radio-group__items {
  gap: 8px;
}

.days-count-modal__presets .ui-radio {
  padding: 8px 12px;
  white-space: nowrap;
  border: 1px solid var(--color-border-border-primary);
  border-radius: var(--radius-md);
}

.days-count-modal__select {
  max-width: 304px;
}
</style>
